import { useContext } from "react";
import { AppContext } from "../contexts/AppContext";

export const useUI = () => {
  const context = useContext(AppContext);
  if (!context) throw new Error("useUI must be used within AppProvider");
  return context;
};
